import { Button, Menu, MoreVertIcon } from '@parspec/pixel';

import { useLocationDetails } from '../../AddEditLocation/context';

export const getSaveOptions = (onOptionClick: (type: string) => void) => [
    { label: 'To this Branch only', onClick: () => onOptionClick('single') },
    { label: 'To multiple Branches', onClick: () => onOptionClick('multiple') }
];

interface SaveButtonProps {
    onOptionSelection: (type: string) => Promise<void>;
    isLoading: boolean
}
export const SaveButton = (props: SaveButtonProps) => {
    const { onOptionSelection, isLoading } = props;
    const { companyDetailsLoading } = useLocationDetails()

    return (
        <>
            <Menu options={getSaveOptions(onOptionSelection)}>
                <Button variant="contained" endIcon={<MoreVertIcon />} isLoading={isLoading} disabled={companyDetailsLoading}>
                    Save
                </Button>
            </Menu>
        </>
    );
};
